import { createGlobalStyle } from 'styled-components';

import tokens from '@quintoandar/cozy-theme/tokens/js';

export const GlobalStyle = createGlobalStyle`
  html,
  body {
    width: 100%;
  }
  body {
    @media all and (max-width: ${tokens.grid.breakpoint.tablet.minWidth}) {
      min-height: calc(100vh + 200px);
    }
  }
  #app {
    min-height: 100%;
    width: 100%;
  }
  h1, h2, h3, h4, h5, h6 {
    font-weight: normal;
    line-height: 1.5em;
    margin: 0;
  }
  p,
  label {
    line-height: 1.5em;
  }
  // Force intercom z-index so the FAB doesn't appear above Dialogs and Snackbars
  // Using "1100" because this is the value between AppBar and Snackbar
  #intercom-container {
    z-index: 1100 !important;
  }
  #intercom-container > * {
    z-index: 1100 !important;
  }
`;

export default GlobalStyle;
